import { createContext } from 'react';

export const Context = createContext({
  currentPage: 'LOGIN',
  courses: [],
  daysLeft: 0,
  language: 'EN',
  stats: { all: 0, selected: 0, left: 0 },

  langDrawerVisibility: false,
  editDrawerVisibility: false,
  courseDrawerVisibility: false,
  courseSubmitName: '',
  courseSubmitFaculty: '',
  langSelectedLangs: [],
  periodData: [],
  courseMaxStudentNumber: '',
  selectionPeriod: [],
  professionData: [],
  selectionPeriodEdit: [],
  selectionPeriodData: [],
  languageData: [],
  courseSelection: [],
  selectionDrawerVisibility: false,

  filters: [],
  userGroups: [],

  keyFeaturesDrawerVisibility: false,
  keyFeaturesDrawerForUpdateVisibility: false,
  keyFeaturesIdWhichWillBeUpdated: null,

  contentDrawerVisibility: false,
  contentDrawerForUpdateVisibility: false,
  contentDrawerToCheckValuesVisibility: false,
  contentIdWhichWillBeUpdated: null,

  builderDrawerVisibility: false,
  builderDrawerForUpdateVisibility: false,
  builderIdWhichWillBeUpdated: null,

  motivationDrawerVisibility: false,
  motivationDrawerForUpdateVisibility: false,
  motivationIdWhichWillBeUpdated: null,

  residentialComplexDrawerVisibility: false,
  residentialComplexDrawerForUpdateVisibility: false,
  residentialComplexIdWhichWillBeUpdated: null,

  queueDrawerVisibility: false,
  queueDrawerForUpdateVisibility: false,
  queueIdWhichWillBeUpdated: null,

  buildDrawerVisibility: false,
  buildDrawerForUpdateVisibility: false,
  buildIdWhichWillBeUpdated: null,
});
